package team.platforma.multiplatform_material_extension.bottom_sheet.style

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Shape
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp

object CommonBottomSheetStyle {
    private var mBackground: Color? = null
    private var mDragHandleColor: Color? = null

    private var mDragHandle: @Composable (color: Color) -> Unit = { color ->
        Box(
            modifier = Modifier
                .padding(16.dp)
                .width(40.dp)
                .height(4.dp)
                .background(color, shape = RoundedCornerShape(2.dp))
        )
    }

    private var mShape: Shape = RoundedCornerShape(topStart = 8.dp, topEnd = 8.dp)
    private var mTonalElevation: Dp = 4.dp

    @Composable
    fun define(
        background: Color = MaterialTheme.colorScheme.background,
        dragHandleColor: Color = MaterialTheme.colorScheme.onBackground,
        dragHandle: @Composable (color: Color) -> Unit = { color ->
            Box(
                modifier = Modifier
                    .padding(16.dp)
                    .width(40.dp)
                    .height(4.dp)
                    .background(color, shape = RoundedCornerShape(2.dp))
            )
        },
        shape: Shape = RoundedCornerShape(topStart = 8.dp, topEnd = 8.dp),
        tonalElevation: Dp = 4.dp
    ) {
        mBackground = background
        mDragHandleColor = dragHandleColor
        mDragHandle = dragHandle
        mShape = shape
        mTonalElevation = tonalElevation
    }

    @Composable
    internal fun background(): Color {
        return mBackground ?: MaterialTheme.colorScheme.background
    }

    @Composable
    internal fun dragHandle(color: Color) {
        mDragHandle(color)
    }

    @Composable
    internal fun dragHandleColor(): Color {
        return mDragHandleColor ?: MaterialTheme.colorScheme.onBackground
    }

    internal fun shape(): Shape {
        return mShape
    }

    internal fun tonalElevation(): Dp {
        return mTonalElevation
    }

}